export interface Article {
  id: string;
  title: string;
  slug: string;
  categoryId: string;
  categoryName: string;
  excerpt: string;
  content: string;
  author: string;
  publishDate: string;
  updateDate: string;
  readTime: string;
  viewCount: number;
  tags: string[];
  imageUrl: string;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: 'jm天堂官方入口最新地址（2026年8月更新）',
    slug: 'jmtiantang-official-entry-2026',
    categoryId: 'tutorial',
    categoryName: '使用教程',
    excerpt: '本文为您提供jm天堂最新的官方入口地址，确保您能够安全、快速地访问平台。我们持续更新地址信息，请收藏本页以获取最新动态。',
    content: `<h2>jm天堂官方入口说明</h2>
<p>jm天堂作为一个广受欢迎的内容平台，始终致力于为用户提供优质的内容资源。由于网络环境的变化，官方入口地址可能会不定期更新。本页面将始终保持最新地址信息，建议您收藏本页以便随时获取最新入口。</p>

<h2>如何获取最新地址</h2>
<p>获取jm天堂最新地址有以下几种途径：</p>
<ol>
<li><strong>收藏本官方网站</strong>：本网站会第一时间更新最新入口地址，是最可靠的获取渠道。</li>
<li><strong>关注官方公告</strong>：平台会通过官方渠道发布地址变更通知。</li>
<li><strong>加入官方社群</strong>：获取实时地址更新和使用帮助。</li>
</ol>

<h2>安全访问提醒</h2>
<p>为确保您的账号安全和访问体验，请注意以下几点：</p>
<ul>
<li>仅通过官方渠道获取入口地址，避免使用来路不明的链接。</li>
<li>注意识别仿冒网站，确认网址正确后再输入账号信息。</li>
<li>建议使用安全的网络环境访问平台。</li>
<li>定期更新密码，开启账号安全保护功能。</li>
</ul>

<h2>常见访问问题</h2>
<h3>无法打开页面怎么办？</h3>
<p>如果您遇到无法打开页面的情况，请尝试以下方法：</p>
<ul>
<li>检查您的网络连接是否正常。</li>
<li>尝试切换不同的网络环境。</li>
<li>清除浏览器缓存和Cookie后重试。</li>
<li>使用推荐的浏览器访问（Chrome、Edge、Firefox等）。</li>
</ul>

<h3>地址失效了怎么办？</h3>
<p>如果发现当前地址无法访问，请返回本页面查看最新更新。我们的团队会持续监控并及时更新有效地址。</p>

<h2>总结</h2>
<p>jm天堂始终以用户体验为核心，我们理解稳定访问对您的重要性。请将本页面加入书签，随时获取最新、最安全的官方入口地址。如有任何问题，欢迎通过关于我们页面的联系方式与我们取得联系。</p>`,
    author: 'jm天堂官方',
    publishDate: '2026-08-10',
    updateDate: '2026-08-12',
    readTime: '5分钟',
    viewCount: 12850,
    tags: ['官方入口', '最新地址', '访问指南', '安全访问'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20digital%20platform%20entrance%20concept%20with%20warm%20amber%20and%20cream%20tones%2C%20abstract%20geometric%20shapes%2C%20soft%20lighting%2C%20minimalist%20design%2C%20digital%20access%20theme%2C%20professional%20atmosphere%2C%20high%20quality%20editorial%20photography%20style&width=800&height=450&seq=article-card-1&orientation=landscape',
  },
  {
    id: 'article-2',
    title: 'jm天堂新用户注册与使用完整指南',
    slug: 'jmtiantang-new-user-guide',
    categoryId: 'tutorial',
    categoryName: '使用教程',
    excerpt: '刚接触jm天堂？本指南将带您从注册账号到熟练使用平台的全部流程，让您快速开启内容探索之旅。',
    content: `<h2>欢迎来到jm天堂</h2>
<p>jm天堂是一个内容资源丰富的平台，无论您是寻找特定类型的内容，还是想要探索新的领域，这里都能满足您的需求。本指南将帮助您快速上手。</p>

<h2>第一步：注册账号</h2>
<p>注册jm天堂账号非常简单：</p>
<ol>
<li>访问jm天堂官方入口页面。</li>
<li>点击右上角的"注册"按钮。</li>
<li>填写您的电子邮箱地址。</li>
<li>设置一个安全的密码（建议使用大小写字母、数字和特殊字符的组合）。</li>
<li>完成验证码验证。</li>
<li>点击"注册"完成账号创建。</li>
</ol>

<h2>第二步：完善个人资料</h2>
<p>注册成功后，建议您完善个人资料以获得更好的使用体验：</p>
<ul>
<li>设置头像和昵称。</li>
<li>选择您感兴趣的内容分类。</li>
<li>设置隐私和安全选项。</li>
</ul>

<h2>第三步：浏览和发现内容</h2>
<p>jm天堂提供多种内容发现方式：</p>
<ul>
<li><strong>分类浏览</strong>：通过分类导航找到您感兴趣的内容类型。</li>
<li><strong>搜索功能</strong>：使用关键词搜索特定内容。</li>
<li><strong>热门推荐</strong>：查看平台推荐的热门内容。</li>
<li><strong>个人推荐</strong>：基于您的浏览历史获得个性化推荐。</li>
</ul>

<h2>第四步：收藏与互动</h2>
<p>找到喜欢的内容后，您可以使用以下功能：</p>
<ul>
<li>收藏内容到个人收藏夹。</li>
<li>对内容进行评分和评论。</li>
<li>分享内容给朋友。</li>
<li>关注感兴趣的内容创作者。</li>
</ul>

<h2>使用建议</h2>
<p>为了获得最佳使用体验，我们建议：</p>
<ul>
<li>定期检查更新，了解平台新功能。</li>
<li>合理使用搜索和筛选功能提高效率。</li>
<li>遵守平台社区规范，文明互动。</li>
</ul>

<h2>遇到问题？</h2>
<p>如果您在使用过程中遇到任何问题，可以查阅我们的常见问题页面，或通过关于我们页面的联系方式获取帮助。我们的团队随时为您服务。</p>`,
    author: 'jm天堂官方',
    publishDate: '2026-08-05',
    updateDate: '2026-08-11',
    readTime: '8分钟',
    viewCount: 9630,
    tags: ['注册指南', '新用户', '使用教程', '入门'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20welcoming%20onboarding%20experience%20concept%2C%20clean%20minimalist%20workspace%20with%20soft%20amber%20lighting%2C%20smooth%20paper%20texture%20background%2C%20gentle%20gradients%2C%20calm%20and%20inviting%20atmosphere%2C%20editorial%20photography%20quality&width=800&height=450&seq=article-card-2&orientation=landscape',
  },
  {
    id: 'article-3',
    title: 'jm天堂内容分类详解：找到您想要的一切',
    slug: 'jmtiantang-category-guide',
    categoryId: 'tutorial',
    categoryName: '使用教程',
    excerpt: '全面了解jm天堂的内容分类体系，帮您快速定位感兴趣的内容类型，提升浏览效率。',
    content: `<h2>jm天堂内容分类概览</h2>
<p>jm天堂拥有丰富多样的内容分类，每个分类下都有大量优质资源。了解分类体系能够帮助您更高效地找到想要的内容。</p>

<h2>主要分类介绍</h2>

<h3>热门推荐</h3>
<p>汇集平台近期最受欢迎的内容，是了解平台热门趋势的最佳入口。每日更新，确保您不错过任何精彩内容。</p>

<h3>最新上架</h3>
<p>展示平台最新添加的内容资源，按发布时间排序。如果您喜欢尝鲜，这里是最佳选择。</p>

<h3>精选合集</h3>
<p>由平台编辑精心策划的专题合集，围绕特定主题或风格整理的内容包，适合想要深度探索的用户。</p>

<h3>经典回顾</h3>
<p>收录平台历久弥新的经典内容，经过时间检验的高质量资源，新用户了解平台品质的绝佳起点。</p>

<h2>如何使用分类功能</h2>
<ol>
<li>在首页或导航栏选择"分类浏览"。</li>
<li>点击感兴趣的分类进入对应页面。</li>
<li>使用页面内的排序和筛选功能进一步缩小范围。</li>
<li>点击内容封面或标题进入详情页。</li>
</ol>

<h2>个性化推荐</h2>
<p>随着您使用平台的深入，jm天堂会根据您的浏览和收藏记录，为您提供个性化的内容推荐。您在平台上的每一次互动都在帮助系统更好地理解您的偏好。</p>`,
    author: 'jm天堂编辑团队',
    publishDate: '2026-07-28',
    updateDate: '2026-08-08',
    readTime: '6分钟',
    viewCount: 7540,
    tags: ['内容分类', '浏览指南', '分类导航'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Organized%20digital%20content%20library%20concept%2C%20warm%20cream%20background%20with%20amber%20accent%20elements%2C%20clean%20grid%20layout%2C%20soft%20shadows%2C%20minimalist%20modern%20design%2C%20professional%20editorial%20style&width=800&height=450&seq=article-card-3&orientation=landscape',
  },
  {
    id: 'article-4',
    title: 'jm天堂账号安全设置完整教程',
    slug: 'jmtiantang-account-security',
    categoryId: 'security',
    categoryName: '安全指南',
    excerpt: '保护您的jm天堂账号安全至关重要。本文详细介绍账号安全设置的各项功能，助您安心使用平台。',
    content: `<h2>账号安全的重要性</h2>
<p>在数字时代，账号安全是每位用户都应重视的问题。jm天堂提供了多层次的账号安全保护措施，我们强烈建议您花几分钟时间完成安全设置。</p>

<h2>基础安全设置</h2>

<h3>设置强密码</h3>
<p>一个强密码应包含：</p>
<ul>
<li>至少12个字符。</li>
<li>大小写字母的组合。</li>
<li>至少一个数字。</li>
<li>至少一个特殊字符（如!@#$%）。</li>
<li>避免使用个人信息（生日、姓名等）。</li>
</ul>

<h3>绑定安全邮箱</h3>
<p>绑定一个您常用的安全邮箱，用于：</p>
<ul>
<li>密码重置。</li>
<li>异常登录提醒。</li>
<li>账号变更通知。</li>
</ul>

<h2>高级安全功能</h2>

<h3>两步验证</h3>
<p>开启两步验证后，即使密码泄露，他人也无法登录您的账号。每次登录需要输入密码和动态验证码。</p>

<h3>登录设备管理</h3>
<p>查看和管理所有登录过您账号的设备，可以远程下线可疑设备。</p>

<h3>登录提醒</h3>
<p>开启后，每次账号在新设备上登录时，您都会收到通知。</p>

<h2>安全使用习惯</h2>
<ul>
<li>不要在公共设备上保存登录状态。</li>
<li>定期更换密码。</li>
<li>警惕钓鱼网站和虚假链接。</li>
<li>不要在多个平台使用相同密码。</li>
</ul>`,
    author: 'jm天堂安全团队',
    publishDate: '2026-07-20',
    updateDate: '2026-08-06',
    readTime: '7分钟',
    viewCount: 6120,
    tags: ['账号安全', '密码设置', '安全指南', '隐私保护'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20security%20and%20protection%20concept%2C%20warm%20minimalist%20shield%20symbol%20on%20cream%20background%2C%20soft%20amber%20glow%2C%20clean%20and%20trustworthy%20aesthetic%2C%20professional%20editorial%20photography&width=800&height=450&seq=article-card-4&orientation=landscape',
  },
  {
    id: 'article-5',
    title: 'jm天堂移动端使用体验优化技巧',
    slug: 'jmtiantang-mobile-tips',
    categoryId: 'tips',
    categoryName: '使用技巧',
    excerpt: '在手机和平板上使用jm天堂？本文分享10个实用的移动端使用技巧，让您随时随地畅享内容。',
    content: `<h2>移动端使用概述</h2>
<p>随着移动互联网的普及，越来越多的用户选择在手机和平板上访问jm天堂。为了提供流畅的移动端体验，我们整理了以下实用技巧。</p>

<h2>十大移动端技巧</h2>

<h3>1. 添加到主屏幕</h3>
<p>将jm天堂添加到手机主屏幕，像使用原生App一样快速访问。在浏览器菜单中选择"添加到主屏幕"即可。</p>

<h3>2. 开启阅读模式</h3>
<p>浏览器自带的阅读模式可以去除干扰元素，提供纯净的阅读体验。适合长时间阅读文章时使用。</p>

<h3>3. 使用手势操作</h3>
<p>熟悉移动端的手势操作可以大大提高浏览效率：左右滑动切换页面、双指缩放图片、长按弹出菜单等。</p>

<h3>4. 离线缓存</h3>
<p>在网络不稳定的环境下，可以提前缓存感兴趣的内容，方便离线查看。</p>

<h3>5. 调整字体大小</h3>
<p>在设置中调整字体大小，找到最适合您阅读习惯的显示效果。</p>

<h3>6. 夜间模式</h3>
<p>在光线较暗的环境下开启夜间模式，减少屏幕对眼睛的刺激。</p>

<h3>7. 数据节省模式</h3>
<p>在使用移动数据时开启节省模式，减少流量消耗。</p>

<h3>8. 快速搜索</h3>
<p>使用搜索栏的语音输入功能，更快地找到想要的内容。</p>

<h3>9. 通知管理</h3>
<p>合理设置推送通知，只接收您关心的内容更新提醒。</p>

<h3>10. 横屏浏览</h3>
<p>在观看图片内容时切换到横屏模式，获得更好的视觉体验。</p>`,
    author: 'jm天堂产品团队',
    publishDate: '2026-07-15',
    updateDate: '2026-08-03',
    readTime: '5分钟',
    viewCount: 4890,
    tags: ['移动端', '使用技巧', '手机访问', '体验优化'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Mobile%20phone%20displaying%20clean%20content%20platform%20interface%2C%20warm%20cream%20background%2C%20soft%20amber%20accents%2C%20minimalist%20tech%20lifestyle%20photography%2C%20gentle%20natural%20light%2C%20editorial%20quality&width=800&height=450&seq=article-card-5&orientation=landscape',
  },
  {
    id: 'article-6',
    title: 'jm天堂平台2026年下半年更新计划',
    slug: 'jmtiantang-2026-update-plan',
    categoryId: 'news',
    categoryName: '最新动态',
    excerpt: '了解jm天堂2026年下半年的产品更新计划，包括新功能、界面优化和内容扩展等重大改进。',
    content: `<h2>2026年下半年更新概览</h2>
<p>jm天堂团队一直在努力提升平台体验。2026年下半年，我们将推出一系列重要更新，以下是主要计划。</p>

<h2>界面全面升级</h2>
<p>我们正在进行界面设计的全面优化：</p>
<ul>
<li>更简洁直观的导航结构。</li>
<li>优化的内容展示布局。</li>
<li>全新的配色方案和视觉风格。</li>
<li>改进的移动端适配体验。</li>
</ul>

<h2>功能新增计划</h2>
<h3>智能推荐引擎</h3>
<p>基于机器学习的智能推荐系统，更准确地理解您的偏好，推荐更符合口味的内容。</p>

<h3>社区互动功能</h3>
<p>新增用户之间的互动功能，包括内容讨论区、用户排行榜和内容评分体系。</p>

<h3>多语言支持</h3>
<p>平台界面将支持多语言切换，方便不同语言背景的用户使用。</p>

<h2>内容扩展</h2>
<p>我们将持续扩展内容库，引入更多优质资源。同时优化内容审核机制，确保平台内容的品质。</p>

<h2>性能优化</h2>
<p>持续优化平台性能，包括：更快的加载速度、更低的资源消耗、更稳定的服务。</p>

<p>我们期待这些更新能为您带来更好的使用体验。如有任何建议，欢迎通过关于我们页面的联系方式反馈给我们！</p>`,
    author: 'jm天堂产品团队',
    publishDate: '2026-08-01',
    updateDate: '2026-08-12',
    readTime: '4分钟',
    viewCount: 8720,
    tags: ['更新计划', '平台动态', '新功能', '公告'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Product%20roadmap%20and%20future%20planning%20concept%2C%20warm%20cream%20background%20with%20amber%20timeline%20elements%2C%20clean%20modern%20aesthetic%2C%20soft%20lighting%2C%20professional%20corporate%20editorial%20style&width=800&height=450&seq=article-card-6&orientation=landscape',
  },
  {
    id: 'article-7',
    title: 'jm天堂资源分享社区使用规范',
    slug: 'jmtiantang-community-rules',
    categoryId: 'resource',
    categoryName: '资源分享',
    excerpt: '了解jm天堂资源分享社区的使用规范和注意事项，共同维护良好的社区氛围。',
    content: `<h2>社区规范概述</h2>
<p>jm天堂资源分享社区是一个开放、友好的交流空间。为了维护良好的社区环境，请所有用户在参与分享和讨论时遵守以下规范。</p>

<h2>内容分享规范</h2>
<ul>
<li>分享内容应符合国家法律法规。</li>
<li>请勿分享侵犯他人知识产权的内容。</li>
<li>分享时应注明内容来源和相关信息。</li>
<li>禁止分享含有恶意软件或病毒的文件。</li>
</ul>

<h2>互动交流规范</h2>
<ul>
<li>尊重他人，文明用语。</li>
<li>禁止发布人身攻击、歧视性言论。</li>
<li>禁止发布垃圾广告和无关信息。</li>
<li>鼓励有建设性的讨论和反馈。</li>
</ul>

<h2>违规处理</h2>
<p>对于违反社区规范的行为，平台将根据情节严重程度采取以下措施：</p>
<ul>
<li>警告提醒。</li>
<li>内容下架。</li>
<li>暂时或永久限制发言权限。</li>
<li>封禁账号。</li>
</ul>

<p>我们希望每一位用户都能在jm天堂找到价值，同时也能为社区贡献自己的力量。让我们共同努力，打造一个优质的资源共享平台。</p>`,
    author: 'jm天堂社区管理',
    publishDate: '2026-07-10',
    updateDate: '2026-08-01',
    readTime: '4分钟',
    viewCount: 3560,
    tags: ['社区规范', '资源分享', '使用规则'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Community%20guidelines%20and%20friendly%20collaboration%20concept%2C%20warm%20cream%20background%2C%20soft%20amber%20and%20green%20accents%2C%20people%20connecting%20abstract%2C%20clean%20minimalist%20design%2C%20editorial%20quality&width=800&height=450&seq=article-card-7&orientation=landscape',
  },
  {
    id: 'article-8',
    title: 'jm天堂常见登录问题及解决方案',
    slug: 'jmtiantang-login-issues',
    categoryId: 'faq',
    categoryName: '常见问题',
    excerpt: '汇总jm天堂用户最常遇到的登录问题，并提供详细的解决方案，帮助您快速恢复访问。',
    content: `<h2>登录问题总览</h2>
<p>登录问题是用户反馈最多的问题类型之一。本文汇总了最常见的登录问题及其解决方案，帮助您快速解决问题。</p>

<h2>常见问题与解决</h2>

<h3>忘记密码怎么办？</h3>
<p>在登录页面点击"忘记密码"，输入注册邮箱，系统会发送密码重置链接到您的邮箱。按照邮件中的指引完成密码重置即可。</p>

<h3>账号被锁定怎么办？</h3>
<p>多次输入错误密码可能导致账号临时锁定。通常等待15-30分钟后会自动解锁。如果紧急需要，可以联系客服协助处理。</p>

<h3>收不到验证邮件？</h3>
<p>请检查以下几点：</p>
<ul>
<li>查看垃圾邮件文件夹。</li>
<li>确认邮箱地址是否正确。</li>
<li>检查邮箱是否已满。</li>
<li>将平台邮箱加入白名单。</li>
</ul>

<h3>提示"账号不存在"？</h3>
<p>请确认您输入的账号信息是否正确。如果确认无误仍提示不存在，可能是账号因违规被处理，请联系客服了解详情。</p>

<h3>登录后频繁掉线？</h3>
<p>可能是以下原因导致：</p>
<ul>
<li>网络连接不稳定。</li>
<li>浏览器缓存问题，尝试清除缓存。</li>
<li>账号在其他设备上登录导致被踢出。</li>
<li>平台服务器维护中。</li>
</ul>`,
    author: 'jm天堂技术支持',
    publishDate: '2026-07-05',
    updateDate: '2026-08-08',
    readTime: '5分钟',
    viewCount: 10240,
    tags: ['登录问题', '常见问题', '故障排除', '账号恢复'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Technical%20support%20and%20problem%20solving%20concept%2C%20warm%20cream%20background%2C%20amber%20accent%20elements%2C%20clean%20help%20desk%20aesthetic%2C%20soft%20lighting%2C%20professional%20editorial%20photography&width=800&height=450&seq=article-card-8&orientation=landscape',
  },
  {
    id: 'article-9',
    title: 'jm天堂搜索功能高级用法指南',
    slug: 'jmtiantang-search-tips',
    categoryId: 'tips',
    categoryName: '使用技巧',
    excerpt: '掌握jm天堂搜索功能的高级用法，使用筛选器和关键词技巧精准定位目标内容。',
    content: `<h2>搜索功能概述</h2>
<p>jm天堂的搜索功能远不止简单输入关键词。掌握以下高级技巧，您可以更精准地找到想要的内容。</p>

<h2>高级搜索技巧</h2>

<h3>精确匹配搜索</h3>
<p>使用引号包围关键词可以进行精确匹配搜索，只返回包含完全相同短语的结果。</p>

<h3>排除关键词</h3>
<p>在关键词前使用减号可以排除包含该词的结果，帮助过滤不相关内容。</p>

<h3>多条件组合搜索</h3>
<p>使用空格分隔多个关键词进行组合搜索，系统会返回同时包含所有关键词的结果。</p>

<h3>分类限定搜索</h3>
<p>先选择内容分类，再输入关键词，可以将搜索范围限定在特定分类内。</p>

<h3>时间范围筛选</h3>
<p>使用时间筛选器，可以限定只搜索特定时间段内发布的内容。</p>

<h3>排序方式</h3>
<p>搜索结果支持多种排序方式：按相关度、按发布时间、按热门程度等。</p>

<h2>搜索建议</h2>
<ul>
<li>使用具体而非宽泛的关键词。</li>
<li>善用同义词和近义词扩大搜索范围。</li>
<li>搜索后使用筛选器进一步缩小范围。</li>
<li>如果搜索结果不理想，尝试调整关键词。</li>
</ul>`,
    author: 'jm天堂产品团队',
    publishDate: '2026-06-28',
    updateDate: '2026-07-30',
    readTime: '4分钟',
    viewCount: 4230,
    tags: ['搜索技巧', '高级功能', '使用技巧', '效率提升'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Smart%20search%20and%20discovery%20concept%2C%20warm%20cream%20background%20with%20amber%20magnifying%20glass%20abstract%2C%20clean%20minimalist%20design%2C%20soft%20lighting%2C%20editorial%20professional%20quality&width=800&height=450&seq=article-card-9&orientation=landscape',
  },
];

export function getArticlesByCategory(categoryId: string): Article[] {
  return articles.filter((a) => a.categoryId === categoryId);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getRecentArticles(count: number = 6): Article[] {
  return [...articles]
    .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime())
    .slice(0, count);
}

export function getPopularArticles(count: number = 6): Article[] {
  return [...articles].sort((a, b) => b.viewCount - a.viewCount).slice(0, count);
}